import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import moment from "moment";

import NavBar from "../../../Component/NavBar/AdminHeader/AdminHeader";
import Axios from "axios";
import { url } from "../../../config/config";
import CustomTableHead from "../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { adminLogout } from "../../../redux/action/action";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./Users.css";
import AdminPageTitle from "../../../Component/AdminPageTitle/AdminPageTitle";
import SearchFilterUser from "./SearchFilterUser/SearchFilterUser";

class ViewUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      search: {
        firstName: "",
        lastName: "",
      },
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Profile Image",
        },
        {
          name: "Username",
        },
        {
          name: "First Name",
        },
        {
          name: "Last Name",
        },
        {
          name: "Email",
        },
        {
          name: "Created Date",
        },
      ],
      userData: [],
      isEmpty: false,
      sessionExpired: false,
    };
  }

  async componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const { data } = await Axios.get(`${url}/api/users`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      if (data.length !== 0) {
        this.setState({
          userData: data,
          isEmpty: false,
        });
      } else {
        this.setState({
          userData: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: { ...this.state.search, [e.target.name]: e.target.value },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    const filtered = this.state.userData.filter((user) => {
      return (
        user.firstName
          .toLowerCase()
          .indexOf(this.state.search.firstName.toLowerCase()) !== -1 &&
        user.lastName
          .toLowerCase()
          .indexOf(this.state.search.lastName.toLowerCase()) !== -1
      );
    });
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}
          <AdminPageTitle title="User List" refreshUrl={this.props.match.url} />

          <Divider />
          <br />

          <div>
            <SearchFilterUser
              data={this.state.search}
              handleChange={this.handleSearch}
            />
            {this.state.userData.length !== 0 ? (
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />
                  <TableBody>
                    {(rowsPerPage > 0
                      ? filtered.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : filtered
                    ).map((user, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor: `${index % 2 ? "#eee" : "white"}`,
                        }}
                      >
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          {user.imageUrl ? (
                            <img
                              src={user.imageUrl}
                              alt="ProfileImage"
                              style={{ width: 100, height: 100 }}
                            />
                          ) : (
                            "Not Available"
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {user.userName ? user.userName : "N/A"}
                        </TableCell>
                        <TableCell align="center">{user.firstName}</TableCell>
                        <TableCell align="center">{user.lastName}</TableCell>
                        <TableCell align="center">{user.email}</TableCell>
                        <TableCell align="center">
                          {moment(new Date(user.createdAt)).format("LL")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            ) : this.state.isEmpty === true ? (
              <CustomEmptyMessage message="There is no any data in the database." />
            ) : (
              <CustomLoader />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewUsers)));
